import classnames from 'classnames';
import React, { useCallback, useContext, useMemo } from 'react';
import { FooterButton } from "./components/FooterButton.js";
import { MaybeWrapper } from "../../../../helper/components/MaybeWrapper.js";
import { Tooltip, RECOMMENDED_TOOLTIP_DELAY } from "../../../tooltip/Tooltip.js";
import { modalContext } from "../../contexts/modalContext.js";
import { useCSSValue } from "../../hooks/useCSSValue.js";
import styles from "./ModalFooter.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ModalFooter = ({
  children,
  className,
  actions
}) => {
  const {
    actions: actionsFromContext
  } = useContext(modalContext);
  const classes = classnames(styles.footer, className);
  const sortFn = useCallback((a, b) => {
    const sortingArr = ['CANCEL', 'SECONDARY', 'PRIMARY', 'SUBMIT'];
    return sortingArr.indexOf(a.semantic) - sortingArr.indexOf(b.semantic);
  }, []);
  const sortedActions = useMemo(() => {
    return (actions ?? actionsFromContext ?? []).sort(sortFn);
  }, [actions, actionsFromContext, sortFn]);
  const getLabel = useCallback(action => {
    if (action.semantic === 'CANCEL') {
      return action.label ?? 'Abbrechen';
    }
    return action.label;
  }, []);
  const {
    ref,
    value: mobileModal
  } = useCSSValue('--mobile-modal');
  const hasSecondaryButton = useMemo(() => sortedActions?.some(action => action.semantic === 'SECONDARY'), [sortedActions]);
  const seperatedCancelButton = useMemo(() => {
    if (hasSecondaryButton) {
      const cancelAction = sortedActions.find(action => action.semantic === 'CANCEL');
      if (cancelAction) {
        return /*#__PURE__*/_jsx(FooterButton, {
          action: cancelAction,
          label: getLabel(cancelAction),
          forceTextButton: mobileModal !== 'true'
        });
      }
    }
    return undefined;
  }, [getLabel, hasSecondaryButton, sortedActions, mobileModal]);

  // Hide footer if there are no actions and no children
  if (sortedActions.length === 0 && !children) {
    return null;
  }
  return /*#__PURE__*/_jsxs("footer", {
    className: classes,
    ref: ref,
    children: [/*#__PURE__*/_jsxs("div", {
      className: classnames(styles.additionalFooterContent, {
        [styles.emptyDiv]: !seperatedCancelButton && !children
      }),
      children: [seperatedCancelButton, children]
    }), sortedActions.length > 0 && /*#__PURE__*/_jsx("div", {
      className: styles.actions,
      children: sortedActions.filter(action => !hasSecondaryButton || action.semantic !== 'CANCEL').map((action, index) => /*#__PURE__*/_jsx(MaybeWrapper, {
        condition: !!action.hint,
        wrapper: component => /*#__PURE__*/_jsx(Tooltip, {
          zIndex: 1040,
          content: action.hint,
          delay: RECOMMENDED_TOOLTIP_DELAY,
          children: component
        }, getLabel(action)),
        children: /*#__PURE__*/_jsx(FooterButton, {
          action: action,
          label: getLabel(action)
        }, index)
      }, getLabel(action)))
    })]
  });
};